import React from 'react';
import { FooterHelp, Link } from '@shopify/polaris';
import t from 'lib/translation';

const Footer: React.FC = () => {
  return (
    <FooterHelp>
      <span>{t('footer.infoText')} </span>
      <Link target="_blank" url="https://verisart.com">
        {t('footer.companyTitle')}
      </Link>
    </FooterHelp>
  );
};

export default Footer;
